
import type { ComplexAttributeConverter } from 'lit'
import type { LinkedToDataType } from '../mixins/dom-linkable-mixin';
import { b64DecodeUnicode, b64EncodeUnicode } from '../functions/base64';

export const PROXY_CONVERTERS: Record<LinkedToDataType, Required<ComplexAttributeConverter<string, string>>> = {
  'string': {
    toAttribute(value, type) {
      return value;
    },
    fromAttribute(value, type) {
      return value ?? '';
    },
  },
  'json': {
    toAttribute(value, type) {
      return JSON.stringify(value);
    },
    fromAttribute(value, type) {
      try { return JSON.parse(value ?? 'null') }
      catch { return null; }
    },
  },
  'base64(string)': {
    toAttribute(value, type) {
      return b64EncodeUnicode(`${PROXY_CONVERTERS['string'].toAttribute(value, type)}`);
    },
    fromAttribute(value, type) {
      return PROXY_CONVERTERS['string'].fromAttribute(b64DecodeUnicode(`${value}`), type)
    },
  },
  'base64(json)': {
    toAttribute(value, type) {
      return b64EncodeUnicode(`${PROXY_CONVERTERS['json'].toAttribute(value, type)}`);
    },
    fromAttribute(value, type) {
      return PROXY_CONVERTERS['json'].fromAttribute(b64DecodeUnicode(`${value}`), type)
    },
  }
};
